<template>
  <!-- 报名信息管理 -->
  <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <!-- <el-button type="primary" size="large" @click="addEditFnc($event)"
      ><el-icon><Plus /></el-icon>添加报名信息</el-button
    > -->
     <el-tooltip
        effect="dark"
        content="点击勾选列表审核选中学员报名状态"
        placement="top-start"
      >
    <el-button type="primary" size="large" @click="checkStatus($event)"
      ><el-icon><Finished /></el-icon>审核报名信息状态</el-button
    >
    </el-tooltip>
     <el-tooltip
        effect="dark"
        content="点击勾选列表导出选中列表数据(Excel格式)"
        placement="top-start"
      >
    <el-button type="primary" size="large" plain @click="exportExcel($event)"
      ><el-icon><DocumentChecked /></el-icon>导出Excel</el-button
    >
    </el-tooltip>
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="RegistrationInfo"
    @update-list="updateList"
    excelName="报名信息管理"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @handleDelete="deleteFnc"
    @searchFnc="searchFnc"
    @changeTime="changeTime"
    @handleSelection="handleSelection"
  >
     <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
  <template #statusNameCustom="scope">
        <el-tag
          v-if="scope.scope.statusName"
          :type="
            scope.scope.statusName == '待审核'
              ? 'danger'
              : scope.scope.statusName == '审核通过'
              ? 'primary'
              : 'warning'
          "
          class="mx-1"
          effect="light"
        >
          {{ scope.scope.statusName }}
        </el-tag>
      </template>
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 审核报名信息状态-->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="checkVisible"
    :title="dialogTitle"
    width="450px"
    draggable
              destroy-on-close
  >
    <el-form
      ref="ruleFormRef"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      label-width="110px"
      class="demo-ruleForm"
      size="large"
      status-icon
    >
      <el-form-item label="表单审核状态" prop="status">
        <el-select
          v-model="ruleForm.status"
          class="m-2 small_input"
          placeholder="请选择表单审核状态"
          size="large"
        >
          <el-option
            v-for="item in statusList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="from_btn">
      <el-button @click="resetForm" size="large">取消</el-button>
      <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
        :disabled = "submitDisabled">提交保存</el-button
      >
      <el-button type="primary" size="large" loading v-else>提交中</el-button>
    </div>
  </el-dialog>
  <!-- 添加-->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="800px"
     draggable
              destroy-on-close
  >
    <AddEditRegistration
      v-if="addEditVisible"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditRegistration>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import store from "../../store/index";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus, formattingDate } from "common/utils";
import {
  getRegistrationInfos,
  removeInfo,
  examineRegistration,
  exportRegistrationInfo,
  getIdentityTypesAsync,
  getEnrollmentTypes,
  getRegistrationSourceTypes,
  getStatusValues,
} from "network/registrationInfo.js";
import AddEditRegistration from "views/registrationInfo/AddEditRegistration.vue";

import {
  reactive,
  onMounted,
  toRefs,
  computed,
  toRaw,
  ref,
  unref,
  watchEffect,
  nextTick,
  getCurrentInstance,
  h
} from "vue";

export default {
  name: "RegistrationInfo",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditRegistration,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "姓名",
          prop: "name",
          width: "120",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "报名类型",
          prop: "enrollmentTypeName",
          width: "180",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "身份证号",
          prop: "identityCode",
          width: "160",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "身份类型",
          prop: "identity",
          width: "180",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "审核状态",
          prop: "statusName",
          width: "180",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
          custom:true
        },
        {
          label: "来源渠道",
          prop: "source",
          width: "180",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "备注",
          prop: "remarks",
          width: "260",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "联系电话",
          prop: "telNumber",
          width: "160",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "QQ号码",
          prop: "qqNumber",
          width: "160",
          align: "center",
          noSetText: "未设置",
        },
          {
          label: "在读专业",
          prop: "currentlyMajor",
          width: "160",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "报考专业",
          prop: "major",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "InputSearch"
        },
        {
          label: "报考院校",
          prop: "school",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "InputSearch"
        },
        {
          label: "报名IP",
          prop: "ipAddress",
          width: "160",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "报名时间",
          prop: "createTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
          // type: "DatePicker",
          type: "DateSelect",
          valueFormat:'YYYY-MM-DD HH:mm:ss',
          dateAndTime: true,
          dateType: "datetime",
          createTimeStart: '',
          createTimeEnd: '',
        },

       
      ],
      columnHideList: [], //所有列
      //筛选项
      search: {
        name: "", //筛选 姓名
        telNumber: "",
        school: "",
        major: "",
        startTime: "",
        endTime: "",
        enrollmentType: "",
        source: "",
        identity: "",
        status: "",
        time: "",
      },
      dialogTitle: "审核报名信息状态",
      checkVisible: false, //审核报名信息状态弹窗
      addEditVisible: false, //添加编辑弹窗
      multipleSelection: [],
      ruleForm: { status: "" },
      rules: {
        status: [{ required: true, message: "请选择报名状态" }],
      },
      enrollmentTypeList: [], // 报名类型
      identityTypesList: [], // 身份类型
      statusList: [], // 审核（报名）状态
      sourceTypesList: [], // 来源渠道
      submitDisabled:false
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      nextTick(() => {
        const instance = getCurrentInstance();
        // 这里打印出来是 undefined，因为 setup 声明周期是 beforeCreated 和 created 合并的，这时候 data 还没有初始化，所以我们要在 onMounted 里打印。

      });
      getEnrollmentTypesData(); // 获取报名信息类型
      getIdentityTypesData(); //获取身份信息类型
      getStatusValuesData(); // 获取审核（报名）状态的所有值
      getSourceTypesData(); // 获取来源渠道
      getListData(); //请求列表数据
      if(data.isDelect){
        data.headerData.push(
          {
          label: "操作",
          prop: "operation",
          width: "100",
          align: "center",
          fixed: "right",
          operation: true,
          edit: false,
          delete: true,
        },
        )
      }
    });

    // 获取报名类型
    const getEnrollmentTypesData = () => {
      getEnrollmentTypes().then((res) => {
        if (res && res.code == 1) {
          data.enrollmentTypeList = res.result;
          data.headerData.map((item) => {
            if (item.prop == "enrollmentTypeName") {
              item.selectOptions = [
                {key:null,value:'报名类型(全部)'},
                ...data.enrollmentTypeList];
            }
          });
        }
      });
    };

    //获取身份类型枚举对象
    const getIdentityTypesData = () => {
      getIdentityTypesAsync().then((res) => {
        if (res && res.code == 1) {
          data.identityTypesList = res.result;
          data.headerData.map((item) => {
            if (item.prop == "identity") {
              item.selectOptions = [
               {key:null,value:'身份类型(全部)'},
                ...data.identityTypesList
              ];
            }
          });
        }
      });
    };

    // 获取审核（报名）状态的所有值
    const getStatusValuesData = () => {
      getStatusValues().then((res) => {
        if (res && res.code == 1) {
          data.statusList = res.result;
          data.headerData.map((item) => {
            if (item.prop == "statusName") {
              item.selectOptions = [
              {key:null,value:'审核状态(全部)'},
                ...data.statusList
              ];
              
            }
          });
        }
      });
    };

    // 获取来源渠道
    const getSourceTypesData = () => {
      getRegistrationSourceTypes().then((res) => {
        if (res && res.code == 1) {
          // data.sourceTypesList = res.result;
          res.result?.map(item=>{
            data.sourceTypesList.push({key:item,value:item})
          })
          data.headerData?.map((item) => {
            if (item.prop == "source") {
              item.selectOptions = [
                {key:null,value:'来源渠道(全部)'},
                ...data.sourceTypesList];
            }
          });
        }
      });
    };
     // 获取列表
    const getListData = () => {
      data.loading = true;
      data.loadingText =  "加载中..."
           const obj = {
        name: data.search.name || null, //筛选 姓名
        telNumber: data.search.telNumber || null,
        school: data.search.school || null,
        major: data.search.major || null,
        startTime: data.search.startTime || null,
        endTime: data.search.endTime || null,
        source: data.search.source || null,
        identity: data.search.identity || null,
        status: data.search.status || null,
        enrollmentType: data.search.enrollmentType || 0,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getRegistrationInfos(obj)
        .then((result) => {
          if (result && result.code == 1) {
            const list = result.result.items;
            data.pagination.total = result.result.allItemsCount;
            const dataList = toRaw(list);
            data.tableData = dataList;
            data.loading = false;
            data.tableData.forEach((i) => {
              data.identityTypesList.forEach((j) => {
                if (i.identity == j.key) {
                  i.identity = j.value;
                }
              });
            });
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

       // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "telNumber") {
        data.search.telNumber = val.value;
      }
      if (val.prop && val.prop == "enrollmentTypeName") {
        data.search.enrollmentType = val.value;
      }
      if (val.prop && val.prop == "identity") {
        data.search.identity = val.value;
      }
      if (val.prop && val.prop == "statusName") {
        data.search.status = val.value;
      }
      if (val.prop && val.prop == "source") {
        data.search.source = val.value;
      } if (val.prop && val.prop == "major") {
        data.search.major = val.value;
      }
       if (val.prop && val.prop == "school") {
        data.search.school = val.value;
      }
      if (val.prop && val.prop == "createTime") {
        data.search.startTime = val.value.start ? val.value.start : null;
        data.search.endTime = val.value.end ? val.value.end : null;
      }
      data.pagination.currentPage = 1;
      getListData();
    };      
        
    //选择时间 筛选
    const changeTime = (val) => {
      data.search.startTime = val.startTime;
      data.search.endTime = val.endTime;
      getListData();
    };

    //更新列表 
    const updateList = () => {
      getListData();
    };
   
    //关闭弹窗
    const closeDialog = () => {
      data.checkVisible = false;
      data.addEditVisible = false;
    };
    //添加
    // const addEditFnc = (e) => {
    //   // 强制移除按钮焦点
    //   lostFocus(e);
    //   data.addEditVisible = true;
    //   data.dialogTitle = "添加报名信息";
    // };

 // 表格多选行处理
    const handleSelection = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };

    // 导出Excel
    const exportExcel = () => {
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请先选择报考信息，可选中一个或多个");
      } else {
        data.loading = true
        data.loadingText =  "提交中..."
        var ids = [];
        data.multipleSelection.map((org) => {
          ids.push(org.id);
        });
        exportRegistrationInfo(ids)
          .then((res) => {
            // 文档流下载
            const blob = new Blob([res],{type:'application/vnd.ms-excel'}); //excel,pdf等
            const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const a = document.createElement("a"); //创建a标签
            a.style.display = "none";
            a.href = href; // 指定下载链接
            a.download = "报名信息.xls"; //指定下载文件名
            a.click(); //触发下载
            URL.revokeObjectURL(a.href); //释放URL对象
            data.loading = false
          })
          .catch((err) => {
            console.log(err);
            data.loading = false
          });
      }
    };
    // 删除
    const deleteFnc = (obj) => {
          ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${obj.name}`
          ),
          h("span", null, "】的报名信息？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonText = "确认中"
            instance.confirmButtonLoading = true
            // 删除接口
            removeInfo(obj.id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      removeInfo(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };
   
    // 审核报名状态
    const checkStatus = () => {
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请先选择报考信息，可选中一个或多个");
      }
      if (data.multipleSelection.length == 1) {
        data.checkVisible = true;
        data.dialogTitle = `审核[${data.multipleSelection[0].name}]的报名信息状态`;
      }

      if (data.multipleSelection.length > 1) {
        data.checkVisible = true;
        data.dialogTitle = `审核当前选中[${data.multipleSelection.length}]人报名信息状态`;
      }
    };
    const ruleFormRef = ref();
    // 提交 审批
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          examineInfo()
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    function examineInfo() {
      var ids = [];
      data.multipleSelection.map((org) => {
        ids.push(org.id);
      });
      const obj = {
        idCollection: ids,
        status: data.ruleForm.status,
      };
      examineRegistration(obj)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            
            data.checkVisible = false;
            data.submitDisabled = false;
            data.ruleForm.status = null
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 取消操作  关闭弹窗
    const resetForm = () => {
      closeDialog();
      ruleFormRef.value.resetFields();
    };
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getListData,
      searchFnc,
      updateList,
      changeTime,
      closeDialog,
      checkStatus,
      exportExcel,
      deleteFnc,
      changePagination,
      handleSelection,
      ruleFormRef,
      submitForm,
      resetForm,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
       };
  },
};
</script>
<style scoped>
</style>

